module.exports = __webpack_public_path__ + "static/media/nutrition-icons.342efe46.svg";